module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapterhead"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('i', [_vm._v("List of Illustrations")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/illustration002#link1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Eildon Hill North under snow.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Mutiny Stones.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Scott’s View.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Anglian fields at Midlem.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Jedburgh Abbey.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Melrose Abbey.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The decorated capital ‘M’ from the Kelso Abbey charter.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Lauder Common Riding.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A swing plough.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. A ploughman and his bondager.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Workers in the darning flat at Gardiners’ Mill, Selkirk.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Workers at Philiphaugh, near Selkirk, in 1890.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Gardeners and foresters at Philiphaugh in the 1890s.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/illustration002#link14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Kelso Abbey")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cacdd42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/illustration001.vue
// module id = 69
// module chunks = 0